var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.667,
    height: 18.515,
    viewBox: "0 0 15.667 18.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_people_person_users_man",
    "data-name": "user people person users man",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M18.345,16.1a.713.713,0,1,0-1,1.011,6.409,6.409,0,0,1,1.9,4.558c0,.869-2.5,2.136-6.409,2.136s-6.409-1.268-6.409-2.136A6.409,6.409,0,0,1,8.3,17.129a.71.71,0,0,0-1-1A7.776,7.776,0,0,0,5,21.665c0,2.314,4.038,3.561,7.833,3.561s7.833-1.246,7.833-3.561A7.791,7.791,0,0,0,18.345,16.1Z",
    transform: "translate(0 -3.711)",
    fill: "#f6c244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M13.985,12.97A4.985,4.985,0,1,0,9,7.985,4.985,4.985,0,0,0,13.985,12.97Zm0-8.545a3.561,3.561,0,1,1-3.561,3.561A3.561,3.561,0,0,1,13.985,4.424Z",
    transform: "translate(-1.152)",
    fill: "#f6c244"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ebf7e026eb91cba4ae38a1cc0fc57044.svg";
export { ForwardRef as ReactComponent };